import React, { useState, FormEvent, ChangeEvent } from "react"
import styled from "styled-components"

import { useStaticQuery, graphql } from "gatsby"
import useFirebase from "../../../useFirebase"
import validate from "../../utils/validations/registerValidation"
import contactForm, { FORM_NAME } from "../../utils/netlifyForms/contactForm"
import OverlayForm, { Input, Textarea, ButtonSubmit } from '../OverlayForm'
import registerForm from "../../utils/netlifyForms/registerForm";

const startingInputs = {
  name: {
    name: "name",
    value: "",
    label: "Name",
  },
  email: {
    name: "email",
    value: "",
    label: "Email",
  }
}

interface ContactFormProps {
  show?: boolean
  onClose?: () => void
  location: Location
}

interface firebaseItem {
  email?: string
}


export default ({ show, onClose, location }: ContactFormProps) => {
  const firebase = useFirebase();
  const data = useStaticQuery(
    graphql`
      query {
        registerImage: file(relativePath: { eq: "stil-N9uOrBICcjY-unsplash.jpg" }) {
          childImageSharp {
            fluid(quality: 20) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `
  )

  const [loading, setLoading] = useState(false)
  const [inputs, setInputs] = useState(startingInputs)
  const [errors, setErrors] = useState<any>({})
  const [submitted, setSubmitted] = useState(false)
  const [spinnerActive, setSpinnerActive] = useState(false)
  const [superError, setSuperError] = useState("")
  const [isValid, setIsValid] = useState(true)

  const handleChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const name = event.target.name
    const value = event.target.value
    const input = inputs[name]

    setInputs({
      ...inputs,
      [name]: { ...input, value: value },
    })
  }

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault()
    
    setSpinnerActive(true)

    const validation = validate(inputs);

    setIsValid(validation.isValid)

    if (validation.isValid) {
      setErrors({});
      registerForm(inputs)
        .then(() => {
          try {
            ;(window as any).dataLayer = (window as any).dataLayer || []
            ;(window as any).dataLayer.push({
              event: "buttonClick",
              category: "radstefna",
              action: "innskraning",
              label: "success",
            })
          } catch {}

          setTimeout(() => {
            const item: firebaseItem = {
              email: inputs.email.value,
            }

            firebase.database().ref("users").push(item)

            if (typeof window !== undefined) {
              localStorage.setItem("loggedIn", inputs.email.value)
              setSpinnerActive(false)
              return true
            }
          }, 1000)
        })
        .then(res => {
          setTitle("Thank you for your registration")
          setText("")
          setSubmitted(true)
        })
        .catch(error => {
          console.log("error" , error)
          setSuperError("Unable to register application")
          setSpinnerActive(false)
        })
    } else {
      console.log("next error")
      setErrors(validation.errors);
      setSpinnerActive(false)
    }
  }

  const [title, setTitle] = useState("Register")
  const [text, setText] = useState(
    "An online symposium hosted by the Prime Minister of Iceland and the Future Committee of Iceland."
  )

  return (
    <OverlayForm
      title={title}
      text={text}
      show={show}
      onClose={onClose}
      imageFluid={data.registerImage}
    >
      <ModalForm className={submitted ? "submitted" : ""}>
        <form name={FORM_NAME} onSubmit={handleSubmit} noValidate>
          <input type="hidden" name="form-name" value={FORM_NAME} />

          <input
            type="hidden"
            name="website-page"
            value={location.pathname}
          />

          <Input 
            type="text"
            label={inputs.name.label}
            name={inputs.name.name}
            id={inputs.name.name}
            placeholder={inputs.name.label}
            onChange={handleChange}
            error={errors.name}
          />

          <Input 
            type="email"
            label={inputs.email.label}
            name={inputs.email.name}
            id={inputs.email.name}
            placeholder={inputs.email.label}
            onChange={handleChange}
            error={errors.email}
          />

          <ButtonSubmit text="Register" loading={loading} spinnerActive={spinnerActive}/>
        </form>
      </ModalForm>
    </OverlayForm>
  )
}

const ModalForm = styled.div`
  &.submitted {
    pointer-events: none;
    opacity: 0;
  }
`
